import styled, { css, keyframes } from "styled-components";

export type VarianteLoader = "logoGradiente" | "sellit" | "semLogo";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Backdrop = styled.div<{ saindo: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;

  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  animation: ${({ saindo }) => (saindo ? fadeOut : fadeIn)} 180ms ease-out;
  animation-fill-mode: forwards;
`;

export const Loader = styled.div<{ variante: VarianteLoader }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  ${({ variante }) =>
    variante === "semLogo"
      ? css`
          width: 48px;
          height: 48px;
        `
      : css`
          width: 96px;
          height: 96px;
        `}
`;

// O anel é um disco em gradiente cônico com o miolo recortado por uma máscara:
// é o que permite girar um gradiente sem deformar o logo que fica no centro.
export const Spinner = styled.div<{ variante: VarianteLoader }>`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;

  ${({ variante }) =>
    variante === "logoGradiente"
      ? css`
          background: conic-gradient(#02de7f, #2d5bff, #02de7f);
        `
      : css`
          background: conic-gradient(#2d74da, #00a99d, #2d74da);
        `}

  ${({ variante }) =>
    variante === "semLogo"
      ? css`
          -webkit-mask: radial-gradient(
            farthest-side,
            transparent 78%,
            black 79%
          );
          mask: radial-gradient(farthest-side, transparent 78%, black 79%);
        `
      : css`
          -webkit-mask: radial-gradient(
            farthest-side,
            transparent 88%,
            black 89%
          );
          mask: radial-gradient(farthest-side, transparent 88%, black 89%);
        `}

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 3s;
  }
`;

export const LogoWrapper = styled.div`
  position: relative;
  width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h3`
  font-family: Inter, Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 6px 0;
`;

export const Description = styled.p`
  font-family: Inter, Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #5a5a5a;
  line-height: 1.5;
  margin: 0;
`;
